import { useEffect, useState } from 'react';
import './App.css'
import Footer from './folder/screens/components/Footer';
import Navbar from './folder/screens/components/Navbar';
import { routes } from './folder/screens/components/routes/router';
import SideBar from './folder/screens/components/SideBar';
import { Routes,Route, BrowserRouter } from 'react-router-dom';
import AOS from 'aos';
import "aos/dist/aos.css";
import Splash from './folder/screens/pages/Splash';
import ScrollToTop from './folder/screens/components/ScrollToTop';
import { Toaster } from 'react-hot-toast';

function App() {

  const [loader,setloader] = useState(true)

  useEffect(()=>{
    AOS.init();
    setTimeout(() => {
      setloader(false)
    }, 2000);
  },[])

  return (
    <div className='w-screen overflow-x-hidden'>
      <Toaster  position="bottom-center" toastOptions={{
        success: {
          style:{
            background:'black',
            color:'white',
            padding:'4px 7px',
            fontSize:'12px',
            borderRadius:'2px',
            iconTheme: {
              fontSize:'4px'
            }
          }
        },
        error: {
          style:{
            background:'black',
            color:'white',
            padding:'4px 7px',
            fontSize:'12px',
            borderRadius:'2px',
            iconTheme: {
              fontSize:'4px'
            }
          }
        }
      }}  />
    {loader ?
    <Splash />
    :
    <BrowserRouter>
    <ScrollToTop />

     <Navbar />
      <Routes>
        {routes.map((screen,index) => (
          <Route key={index} exact path={screen.path}  element={screen.component} />
        ))}
      </Routes>
      <Footer />
    </BrowserRouter>
    }  
    </div>
  );
}

export default App;
